import { IWindow } from '../services/analytics/adapters/mparticle'

declare let window: IWindow

/**
 * Screen related helper functions
 */

export class Debug {

    public static async mParticleId() {
        return await new Promise((resolve) => {
            window.mParticle.ready(() => {
                resolve(window.mParticle.Identity.getCurrentUser().getMPID())
            })
        })
    }

    public static async deviceId() {
        return await new Promise((resolve) => {
            window.mParticle.ready(() => {
                resolve(window.mParticle.getDeviceId())
            })
        })
    }

    public display() {
        const params = (new URL(String(document.location))).searchParams
        if (params.has('fem_debug')) {
            Debug.mParticleId().then((mpId) => {
                // console.log(mpId)
                const div = document.createElement('div')
                div.className = 'mparticle-id'
                div.innerHTML = 'mParticle Id: ' + mpId
                document.body.appendChild(div)
            }, () => {
                // console.log('mParticle Id not available')
            })

            Debug.deviceId().then((dId) => {
                // console.log(dId)
                const div = document.createElement('div')
                div.className = 'device-id'
                div.innerHTML = 'Device Id: ' + dId
                document.body.appendChild(div)
            }, () => {
                // console.log('Device Id not available')
            })
        }
    }
}
